import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import Routes from 'Routes';
import { PAGE_NAMES } from 'appenv';
import Footer from 'components/Footer';
import exhibitionImg from 'assets/main_lobby/exhibition.png';
import webinarImg from 'assets/main_lobby/webinar.png';
import MobileBannerView from './MobileBannerView';
import mobileBannerAssets from './mobileBannerAssets';

const RootContainer = styled.div`
  width: 100%;
  height: inherit;
  max-width: 800px;
  display: flex;
  flex-direction: column;
  margin: auto;
`;

const StyledLinkContainer = styled.div`
  flex: 0 0 auto;
  position: relative;
  border-radius: 8px;
  overflow: hidden;
  margin: 24px 16px;
  padding-bottom: 49.56%;

  background: url(${({ imgSrc }) => imgSrc});
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
`;

const StyledLink = styled(Link)`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  text-decoration: none;
  overflow: hidden;
`;

const StyledText = styled.div`
  flex: 0 0 auto;
  font-weight: 900;
  font-size: 24px;
  line-height: 30px;
  letter-spacing: -0.408px;
  color: #FFF;
`;

const FooterWrapper = styled.div`
  flex: 0 0 auto;
  display: flex;
  flex-grow: 1;
  justify-content: center;
  align-items: flex-end;
`;

const MobileLobbyView = () => (
  <RootContainer>
    <MobileBannerView
      assets={mobileBannerAssets}
    />
    <StyledLinkContainer imgSrc={exhibitionImg}>
      <StyledLink to={Routes.hall}>
        <StyledText>
          {PAGE_NAMES.hall}
        </StyledText>
      </StyledLink>
    </StyledLinkContainer>
    <StyledLinkContainer imgSrc={webinarImg}>
      <StyledLink to={Routes.webinar}>
        <StyledText>
          {PAGE_NAMES.webinar}
        </StyledText>
      </StyledLink>
    </StyledLinkContainer>
    <FooterWrapper>
      <Footer hashState="/main-lobby" />
    </FooterWrapper>
  </RootContainer>
);

export default MobileLobbyView;
